var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.publishedImage.url)?_c('div',{on:{"click":_vm.recordClick}},[_c('a',{attrs:{"href":_vm.publishedImage.clickUrl,"target":"new"}},[_c('img',{staticStyle:{"border-radius":"10px"},attrs:{"src":_vm.publishedImage.url}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }